import React from 'react';
import { useI18n } from '../i18n/I18nContext';

const UKFlag = () => (
  <svg viewBox="0 0 60 36" className="w-full h-full block" preserveAspectRatio="xMidYMid slice">
    <rect width="60" height="36" fill="#012169" />
    <path d="M0,0 L60,36 M60,0 L0,36" stroke="#fff" strokeWidth="6" />
    <path d="M0,0 L60,36 M60,0 L0,36" stroke="#C8102E" strokeWidth="3" />
    <path d="M30,0 V36 M0,18 H60" stroke="#fff" strokeWidth="10" />
    <path d="M30,0 V36 M0,18 H60" stroke="#C8102E" strokeWidth="6" />
  </svg>
);

const NOFlag = () => (
  <svg viewBox="0 0 22 16" className="w-full h-full block" preserveAspectRatio="xMidYMid slice">
    <rect width="22" height="16" fill="#EF2B2D" />
    <rect x="6" width="2" height="16" fill="#fff" />
    <rect y="7" width="22" height="2" fill="#fff" />
    <rect x="6.5" width="1" height="16" fill="#002868" />
    <rect y="7.5" width="22" height="1" fill="#002868" />
  </svg>
);

/**
 * Reusable language switcher (UK / Norway flags with EN / NO labels).
 * variant="inline"   => use inside a header/nav row (sits next to Log in)
 * variant="floating" => fixed top-right (mimics nav placement on pages without NavBar)
 */
export const LanguageSwitcher = ({ variant = 'inline' }) => {
  const { lang, setLang } = useI18n();

  const FlagPill = ({ code, label, svg }) => {
    const active = lang === code;
    return (
      <button
        data-testid={`lang-flag-${code}`}
        onClick={() => setLang(code)}
        aria-label={`Switch language to ${label}`}
        title={label}
        className={`flex items-center gap-1.5 pl-1.5 pr-2.5 py-1 rounded-full border-2 transition-all ${
          active
            ? 'border-blue-600 bg-blue-50 shadow-sm'
            : 'border-slate-200 bg-white hover:border-slate-400 opacity-80 hover:opacity-100'
        }`}
      >
        <span className="w-7 h-5 rounded-sm overflow-hidden border border-slate-300 block">
          {svg}
        </span>
        <span className={`text-xs font-bold tracking-wide ${active ? 'text-blue-700' : 'text-slate-600'}`}>
          {code.toUpperCase()}
        </span>
      </button>
    );
  };

  const inner = (
    <div data-testid="language-switcher" className="flex items-center gap-1.5">
      <FlagPill code="en" label="English" svg={<UKFlag />} />
      <FlagPill code="no" label="Norsk" svg={<NOFlag />} />
    </div>
  );

  if (variant === 'floating') {
    return (
      <div className="fixed top-3 right-3 sm:top-4 sm:right-4 z-[60] bg-white/95 backdrop-blur-sm rounded-full p-1.5 shadow-lg border border-slate-200">
        {inner}
      </div>
    );
  }
  return inner;
};
